import { AxiosPromise } from 'axios';
import request from '@/utils/request';
import { SpuOfferListQuery, CoinsSpuInfoShowVo } from './type';

/**
 * spu展示页面
  金币业务sku卡片列表 查询
  GET /product/urlMapping/game-service/getCoinsSpuInfoShowVo
  接口ID：257336689
  接口地址：https://app.apifox.com/link/project/4822917/apis/api-257336689
 */
export const getSpuCardList = (params: SpuOfferListQuery): AxiosPromise<CoinsSpuInfoShowVo> => {
  return request({
    url: '/product/urlMapping/game-service/getCoinsSpuInfoShowVo',
    method: 'get',
    params
  });
};
